function formatProductMoney(cents) {
  var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
  return (cents / 100).toLocaleString(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency });
}

function initMainProduct(root) {
  if (!root || root.dataset.mainProductInitialized) return;
  root.dataset.mainProductInitialized = 'true';
    /* gallery stage switching (images + videos) */
    var stage = root.querySelector('[data-stage]');
    var badge = stage ? stage.querySelector('.pdp__sale-badge') : null;
    if (stage) {
      root.querySelectorAll('[data-thumb-kind]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var kind = btn.getAttribute('data-thumb-kind');
          var current = stage.querySelector('img, video, iframe');
          if (current) current.remove();
          var insertImage = function () {
            var img = document.createElement('img');
            img.src = btn.getAttribute('data-thumb-src');
            img.alt = btn.getAttribute('data-thumb-alt') || '';
            img.width = 1000;
            img.height = 1000;
            stage.insertBefore(img, badge);
          };
          if (kind === 'image') {
            insertImage();
          } else {
            var src = root.querySelector('[data-video-source="' + btn.getAttribute('data-thumb-video') + '"]');
            if (src && src.firstElementChild) {
              var clone = src.firstElementChild.cloneNode(true);
              /* hidden sources render without autoplay; start playback only
                 once the clone lands on the visible stage */
              if (clone.tagName === 'VIDEO') {
                clone.setAttribute('autoplay', '');
                clone.muted = true;
                var playing = clone.play && clone.play();
                if (playing && playing.catch) playing.catch(function () {});
              }
              stage.insertBefore(clone, badge);
            } else {
              /* video source missing — fall back to the media image instead of a blank stage */
              insertImage();
            }
          }
          root.querySelectorAll('.pdp__thumb').forEach(function (t) { t.classList.remove('pdp__thumb--active'); });
          btn.classList.add('pdp__thumb--active');
        });
      });
    }
    /* qty stepper */
    root.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        /* scope to the stepper's own .pdp__qty so a second buy form's
           quantity input is never touched */
        var scope = btn.closest('.pdp__qty');
        var input = scope ? scope.querySelector('input[name="quantity"]') : null;
        if (!input) return;
        var next = parseInt(input.value || '1', 10) + parseInt(btn.getAttribute('data-qty'), 10);
        input.value = Math.min(99, Math.max(1, next));
      });
    });
    /* AJAX add to cart — target every real buy form by class (two buy_buttons
       blocks in one section each render their own form); the hidden
       installment helper form in the price block also posts to /cart/add */
    var buyForms = root.querySelectorAll('form.pdp__form');
    buyForms.forEach(function (f) { f.setAttribute('data-ajax-cart', ''); });
    /* the sticky bar keeps driving the first form */
    var form = buyForms[0];
    /* custom buy now — add to cart, then go straight to checkout */
    root.querySelectorAll('[data-buy-now]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        /* the button renders inside its form (before endform), so closest()
           finds the right one; fall back to the first form just in case */
        var f = btn.closest('form') || form;
        if (!f) return;
        var data = new FormData(f);
        /* never post without a variant id */
        if (!data.get('id')) return;
        btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', body: data })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            window.location.href = '/checkout';
          })
          .catch(function () { btn.disabled = false; });
      });
    });
    /* sticky bar */
    var bar = root.querySelector('[data-sticky-bar]');
    var stickyAtc = root.querySelector('[data-sticky-atc]');
    if (stickyAtc && form) {
      stickyAtc.addEventListener('click', function () {
        if (form.requestSubmit) {
          form.requestSubmit();
          return;
        }
        /* older browsers: click the real submit button so the submit event
           (and the AJAX handler) still fires */
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) { submitBtn.click(); } else { form.submit(); }
      });
    }
    /* variant picker and buy buttons are separate blocks: on change, sync the
       hidden variant id plus price, compare price, SKU, sale badges, stock
       note and ATC state from the data attributes on the selected option.
       One buy_buttons block = one form = one hidden id input; sync them all
       so a second buy form can never post a stale variant id. */
    var idInputs = root.querySelectorAll('[data-variant-id-input]');
    var priceEls = root.querySelectorAll('[data-price-value]');
    var compareEl = root.querySelector('[data-compare-value]');
    var saleTag = root.querySelector('[data-sale-tag]');
    var skuEl = root.querySelector('.pdp__sku-value');
    var stockNote = root.querySelector('[data-stock-note]');
    var mainAtc = root.querySelector('.pdp__atc');
    var atcBtns = [];
    root.querySelectorAll('.pdp__atc').forEach(function (btn) { atcBtns.push(btn); });
    if (stickyAtc) atcBtns.push(stickyAtc);
    /* custom buy-now follows the same sold-out disable/restore as ATC; it has
       no [data-atc-label], so the label swap below simply skips it */
    root.querySelectorAll('[data-buy-now]').forEach(function (btn) { atcBtns.push(btn); });
    atcBtns.forEach(function (btn) {
      var label = btn.querySelector('[data-atc-label]');
      /* liquid renders data-default-label with the available-state copy; only
         fall back to the current text when it is missing and the variant is
         available, so a sold-out deep link never poisons the restore value */
      if (label && !btn.hasAttribute('data-default-label') && !btn.disabled) {
        btn.setAttribute('data-default-label', label.textContent);
      }
    });
    root.querySelectorAll('[data-variant-source]').forEach(function (input) {
      input.addEventListener('change', function () {
        idInputs.forEach(function (el) { el.value = input.value; });
        /* dropdowns carry the variant data on the selected <option>, pills on the input itself */
        var src = input.tagName === 'SELECT' ? input.options[input.selectedIndex] : input;
        if (!src) return;
        var priceCents = parseInt(src.getAttribute('data-price-cents') || '0', 10);
        var compareCents = parseInt(src.getAttribute('data-compare-cents') || '0', 10);
        var price = formatProductMoney(priceCents);
        var compare = compareCents > priceCents ? formatProductMoney(compareCents) : '';
        var available = src.getAttribute('data-available') !== 'false';
        priceEls.forEach(function (el) { el.textContent = price; });
        if (compareEl) {
          compareEl.textContent = compare || '';
          compareEl.style.display = compare ? '' : 'none';
        }
        if (saleTag) saleTag.style.display = compare ? '' : 'none';
        if (badge) {
          if (compareCents > priceCents && priceCents > 0) {
            badge.textContent = 'Save ' + Math.round(((compareCents - priceCents) * 100) / compareCents) + '%';
            badge.style.display = '';
          } else {
            badge.style.display = 'none';
          }
        }
        if (skuEl) skuEl.textContent = src.getAttribute('data-sku') || '';
        if (stockNote) stockNote.textContent = available ? stockNote.getAttribute('data-stock-note') : 'Sold Out';
        atcBtns.forEach(function (btn) {
          btn.disabled = !available;
          var label = btn.querySelector('[data-atc-label]');
          if (label) label.textContent = available ? btn.getAttribute('data-default-label') : 'Sold Out';
        });
        /* let other sections (FBT's current-product item) follow the selected
           variant; single-variant products render no [data-variant-source],
           so this never fires for them */
        document.dispatchEvent(new CustomEvent('ougist:variant-change', {
          detail: { id: input.value, price: parseInt(src.getAttribute('data-price-cents') || '0', 10) }
        }));
      });
    });
    /* sticky bar appears once the main ATC button scrolls out of view;
       observer lifecycle is tied to the section in the theme editor */
    if (bar && mainAtc && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (bar.toggleAttribute) {
            bar.toggleAttribute('data-open', !entry.isIntersecting);
          } else if (entry.isIntersecting) {
            bar.removeAttribute('data-open');
          } else {
            bar.setAttribute('data-open', '');
          }
        });
      });
      observer.observe(mainAtc);
      document.addEventListener('shopify:section:unload', function (event) {
        if (event.target && event.target.contains && event.target.contains(bar)) observer.disconnect();
      });
      document.addEventListener('shopify:section:load', function (event) {
        if (event.target && event.target.contains && event.target.contains(bar)) bar.removeAttribute('data-open');
      });
    }
}

document.querySelectorAll('[data-main-product-section]').forEach(initMainProduct);
document.addEventListener('shopify:section:load', function (event) {
  var root = event.target.matches && event.target.matches('[data-main-product-section]')
    ? event.target
    : event.target.querySelector && event.target.querySelector('[data-main-product-section]');
  if (root) initMainProduct(root);
});
